export enum TrackingEventEnums {
	CLIENT_REVIEW_EXPORT = 'ClientReviewExport',
	BUSINESS_UNIT_DIRECTOR_REVIEW_EXPORT = 'BusinessUnitDirectorReviewExport',
	INTERNAL_ALL_COLUMNS_EXPORT = 'InternalAllColumnsExport',
	UNKNOWN_OPTION_EXPORT = 'UnknownOptionExport'
}
